'use client'
import { useState } from 'react';
import { motion } from 'framer-motion';
import s from './centered.module.scss';
import ProjectFeaturedComponent from '@/components/singles/projectFeatured';
import { Status, Region, Typology } from '@/types/singles/category';
import { Image } from '@/types/common/ImageData';
import LazyImage from '@/components/common/LazyImage';

interface CenteredProps {
    data: any;
}

export default function Centered({ data }: CenteredProps) {

    return (
    <>
        <motion.div  
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            viewport={{ once: true }} 
            className={`${s.hero} ${s.black}`} 
            style={{ backgroundColor: `${data.color ? data.color : 'transparent'}` }}>
            <div className={s.heroContent}>
                <div className={s.heroText}>
                    <h1>{data.journal.title}{data.journal.secondTitle && <>: <br></br>{data.journal.secondTitle}</>}</h1>
                    {data.journal && data.journal.featuredImage && data.journal.featuredImage.image && <div
                        className={s.heroImageContain} 
                        style={{aspectRatio: data.journal.featuredImage.image.metadata.dimensions.width / data.journal.featuredImage.image.metadata.dimensions.height}}>
                                
                            <LazyImage
                                src={data.journal.featuredImage.image.imageUrl}
                                width={data.journal.featuredImage.image.metadata.dimensions.width}
                                height={data.journal.featuredImage.image.metadata.dimensions.height}
                                blurDataURL={data.journal.featuredImage.image.ref}
                                fill={true}
                                alt={data.journal.featuredImage.image.attribution || ""}
                                caption={data.journal.featuredImage.image.caption || null}
                                filename={data.journal.featuredImage.image.filename || ""}
                            />
                        
                    </div>}
                    <div>
                        {data.journal.subtitle && <p className={s.h1}>{data.journal.subtitle}</p>}
                        {data.journal.author && <p className={s.author}><span>Written By</span> <span>{data.journal.author}</span></p>}
                    </div>
                </div>
            </div>
        </motion.div>

    </>
    );
}